// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 148 ? "69b2bcf5" : chunkId) + "." + {"148":"1e05a8983516c7d8","745":"b9f4a0770ddd3a01","880":"4ddc174674a2c3c4"}[chunkId] + ".js";
};